import React, { useState } from "react";
import api from "../api/axios";

const AddDownload = () => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    isHome: true,
    status_Info: 1,
    app_Web: "",
    remark: "",
    upload1: null,
    upload2: null,
  });

  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === "file") {
      setFormData({ ...formData, [name]: files[0] });
    } else if (type === "checkbox") {
      setFormData({ ...formData, [name]: checked });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMsg("");
    setErrorMsg("");

    const data = new FormData();
    data.append("Name", formData.name);
    data.append("Description", formData.description);
    data.append("IsHome", formData.isHome ? 1 : 0);
    data.append("Status_Info", formData.status_Info);
    data.append("App_Web", formData.app_Web);
    data.append("Remark", formData.remark);
    data.append("Created_By", 1); // optional user ID
    data.append("Updated_By", 1); // optional user ID
    data.append("Created_Date", new Date().toISOString());
    data.append("Updated_Date", new Date().toISOString());

    if (formData.upload1) data.append("Upload1", formData.upload1);
    if (formData.upload2) data.append("Upload2", formData.upload2);

    try {
      const res = await api.post("/Master/AddDownload", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log(res.data);
      setSuccessMsg("Download item added successfully!");
      setFormData({
        name: "",
        description: "",
        isHome: true,
        status_Info: 1,
        app_Web: "",
        remark: "",
        upload1: null,
        upload2: null,
      });
    } catch (err) {
      console.error(err);
      setErrorMsg("Error uploading download. Please try again.");
    }
  };

  return (
       <div className="card shadow">
      <div className="card-header bg-primary text-white">
        <h4>Add Download</h4>
      </div>

      <div className="card-body">
      {successMsg && <div style={{ color: "green" }}>{successMsg}</div>}
      {errorMsg && <div style={{ color: "red" }}>{errorMsg}</div>}

      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="row">
          <div className="col-md-12 mb-3">
            <input
              type="text"
              name="name"
              placeholder="Title"
              value={formData.name}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>

        

          <div className="col-md-12 mb-3">
            <textarea
              name="description"
              placeholder="Description"
              value={formData.description}
              onChange={handleChange}
              className="form-control"
              rows="3"
            ></textarea>
          </div>

          <div className="col-md-6 mb-3">
            <input
              type="file"
              name="upload1"
              onChange={handleChange}
              className="form-control"
            />
          </div>

          <div className="col-md-6 mb-3">
            <input
              type="file"
              name="upload2"
              onChange={handleChange}
              className="form-control"
            />
          </div>

          {/* <div className="col-md-12 mb-3">
            <textarea
              name="remark"
              placeholder="Remark"
              value={formData.remark}
              onChange={handleChange}
              className="form-control"
              rows="2"
            ></textarea>
          </div> */}

            {/* <div className="col-md-6 mb-3">
            <input
              type="text"
              name="app_Web"
              placeholder="App/Web"
              value={formData.app_Web}
              onChange={handleChange}
              className="form-control"
            />
          </div> */}

          <div className="col-md-12 mb-3  mt-3 text-center">
            <label>
              <input
                type="checkbox"
                name="isHome"
                checked={formData.isHome}
                onChange={handleChange}
              />{" "}
              Show on Home
            </label>
          </div>

          <div className="col-md-12 mb-3 text-center">
            <button type="submit" className="btn btn-primary">
              Submit Download
            </button>
          </div>
        </div>
      </form>
    </div>
    </div>
  );
};

export default AddDownload;
